const Handlebars = require('handlebars')
const $ = require('jquery')

const { URL_TEMPLATES } = require('./api')

/**
 * [ajaxLoader description]
 * @type {Object}
 */
const ajaxLoader = {
  /**
   * @name - ajaxLoader
   * @method for initialization ajax calls
   * @param  {Object} config
   * @return
   */
  init (config) {
    const reqAjax = $.ajax({
      method: config.method,
      url: config.url,
      beforeSend () {
        config.beforeSendRequest && config.beforeSendRequest()
      },
      success (results) {
        if (config.type == 'all') {
          ajaxLoader.getTemplate(config.templateName, results).done(function(data) {
            ajaxSuccess(data)
          })

        } else if (config.type == 'gallery') {
          ajaxLoader.getTemplate(config.templateName, { 'elements': results }).done(function(data) {
            ajaxSuccess(data)
          })

        } else if (config.type == 'html') {
          setTimeout(ajaxSuccess(results), 300)
        } else if (config.type == 'html-prepend') {
          setTimeout(ajaxSuccessPrepend(results), 300)

        } else if (config.type == 'tooltip') {
          ajaxLoader.getTemplate(config.templateName, results).done(function(data) {
            ajaxSuccess(data)
          })

        } else if (config.type == 'offersList') {
          if (config.sortOption) {
            config.placeholder.empty()
          }
          ajaxLoader.getTemplate(config.templateName, results).done(function(data) {
            ajaxSuccess(data)
          })
        } else if (config.type == 'bookingForm') {
          config.placeholder[0].elem.html(results.FullPriceParsed)
          config.placeholder[1].elem.html(results.AdultPrice)

          config.callback && config.callback(results)

        } else if (config.type == 'offersTable') {
          // Config.passedFilterData - data that comes after change in offers configurator filter
          results.passedFilterData = config.passedFilterData
          ajaxLoader.getTemplate(config.templateName, { 'Offers': results }).done(function(data) {
            if (config.clearPlaceholder) {
              config.placeholder.empty()
            }
            ajaxSuccess(data)
          })

        } else if (config.type == 'orderAdditionalServices') {
          ajaxLoader.getTemplate(config.templateName, { 'ServicesList': results }).done(function(data) {
            ajaxSuccess(data, results)
          })
        }

        setTimeout(function() {
          config.afterSuccess && config.afterSuccess(results)
        }, 500)
      },
      error (xhr, ajaxOptions, thrownError) {
        log.debug(xhr)
        log.debug(ajaxOptions)
        log.debug(thrownError)
      },
    })
    reqAjax.always = function() {
      ajaxLoader.requests = ajaxLoader.requests.filter(req => req !== reqAjax)
    }
    ajaxLoader.requests.push(reqAjax)

    function ajaxSuccess (data, result) {
      config.placeholder.append(data)
      config.callback && config.callback(result)
    }

    function ajaxSuccessPrepend (data, result) {
      config.placeholder.prepend(data)
      config.callback && config.callback(result)
    }

    $('.modal__close').on('click', function() {
      reqAjax.abort()
    })
    $(document).on('keydown', function(e) {
      const keycode = ((typeof e.keyCode != 'undefined' && e.keyCode) ? e.keyCode : e.which)
      if (keycode === 27) {
        //If (!ajaxInProcess) {
        reqAjax.abort()
        //}
      }
    })
  },
  requests: [],
  abort () {
    for (const k in ajaxLoader.requests) {
      if (Object.hasOwn(ajaxLoader.requests, k)) {
        ajaxLoader.requests[k].abort()
      }
    }
  },
  /**
     * [getTemplate description]
     * @param  {String} templateName [description]
     * @param  {Array|Object} data         [description]
     * @return {[type]}              [description]
     */
  getTemplate (templateName, data) {
    const d = $.Deferred()
    $.get(URL_TEMPLATES + templateName, function(response) {
      const theTemplate = Handlebars.compile(response)
      d.resolve(theTemplate(data))
    })
    return d.promise()
  },
}

module.exports = ajaxLoader



// WEBPACK FOOTER //
// ./src/modules/ajaxLoader.js